<template>
  <div class="p-learning-switch">
    <ul class="c-form-tab">
      <li
        v-for="item in PERIODS"
        :key="item.value"
        :class="{'current': item.value === props.period}"
      >
        <a href="#" @click.prevent="emit('click', item.value)">
          <span class="label">{{item.name}}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import { PERIODS } from "@/consts/display_period";

  const props = withDefaults(
    defineProps<{
      period?: number;
    }>(),
    {
      period: PERIODS[0].value
    }
  )
  const emit = defineEmits<{
    (e: 'click', value: number): void
  }>()
</script>

<style lang="scss" scoped>
</style>
